<mat-form-field class="default-input">
  <mat-label>{{ comboboxHeading }}</mat-label>
  <!-- [disabled]="disabled" -->
  <mat-select [formControl]="comboboxControl"  (selectionChange) = "optionSelected()" [required]="isRequired" [multiple]="multipleAllowed" [panelClass]="MenuClass">
    <mat-option>
      <ngx-mat-select-search [placeholderLabel]="comboboxPlaceholderName" [formControl]="comboboxFilterCtrl" (keyup)="filterForFront(comboboxFilterCtrl.value)" noEntriesFoundLabel="No matching value found"></ngx-mat-select-search>
    </mat-option>
    @if (multipleAllowed && allAllowed) {
<mat-option #allS name="allS" [value]="-1" (onSelectionChange)="toggleAll()">All</mat-option>
}
    @for (option of filteredOptions; track option) {
<mat-option [disabled]="isAllSelected" [value]="option">
      {{ option[column] + ((additionalColumn != null && option[additionalColumn]) ? (" | " + option[additionalColumn]) : "") }}
    </mat-option>
}
  </mat-select>
  @if (comboboxControl.hasError('required')) {
<mat-error>You must make a selection.</mat-error>
}
</mat-form-field>